import { ShieldCheck, Users, Scale, BadgeCheck } from "lucide-react";
import { useI18n } from "@/i18n";
import { Reveal, SectionHead } from "./Reveal";

const ICONS = [ShieldCheck, Users, Scale, BadgeCheck];

export const Principles = () => {
  const { t } = useI18n();
  return (
    <section data-testid="principles-section" className="border-t border-white/10 py-24 lg:py-40">
      <div className="wrap">
        <SectionHead label={t.principles.label} title={t.principles.title} />
        <div className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {t.principles.items.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={p.title} delay={i * 0.07} data-testid={`principle-${i + 1}`} className="group flex h-full flex-col border border-white/10 bg-ink-2 p-7 transition-[border-color,transform] duration-500 hover:-translate-y-1 hover:border-signal/60 lg:p-8">
                <span className="grid h-12 w-12 place-items-center bg-signal/10 text-signal transition-colors duration-500 group-hover:bg-signal group-hover:text-ink"><Icon className="h-5 w-5" /></span>
                <h3 className="mt-10 font-display text-xl font-semibold tracking-tight">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-zinc-400">{p.desc}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
